
export default {
	getIndexInfo: '/web/index/get_index_info.html',
    
}